// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-wrapper {
  height: 100%;
}
.order-wrapper.recomendation {
  height: 95vh;
}
.order-wrapper h1 {
  padding: 0 20px;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  vertical-align: middle;
  color: var(--ion-color-dark);
}
.order-wrapper.eintracht .order-header h1 {
  position: relative;
  font-family: AppFontEintrachtOFC;
  color: #fff;
  margin: 0 auto;
  padding: 12px 20px 20px;
  font-size: 30px;
}
.order-wrapper.eintracht .order-header h1::after {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 20px;
  height: 3px;
  width: 182px;
  background: var(--ion-color-eintracht-red);
}
.order-wrapper.eintracht .order-header .pickup-location {
  background: #000000;
  margin: 11px 20px 12px;
  padding: 10px;
  clip-path: none;
}
.order-wrapper.eintracht .order-header .pickup-location h3,
.order-wrapper.eintracht .order-header .pickup-location .pickup-location-text h4 {
  margin: 0;
  font-family: AppFontEintrachtOFCSans;
  font-weight: 400;
  font-size: 22px;
  line-height: 120%;
}
.order-wrapper.eintracht .order-header .pickup-location .pickup-location-text {
  margin-left: 0;
}
.order-wrapper.eintracht .order-header .pickup-location .pickup-location-text h4 span {
  font-weight: 400;
  color: #E30613;
}

.footer-finish-btn.eintracht {
  background: #121212;
  padding: 17px 20px 25px;
}
.footer-finish-btn.eintracht .amex-offer {
  margin: 0 0 14px;
}
.footer-finish-btn.eintracht .checkout-btn {
  --border-width: 0px;
  height: 50px;
  min-height: 50px;
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 130%;
}
.footer-finish-btn.eintracht .footer-btn-outline {
  --border-color: #E30613;
  border-radius: 6px;
  margin: 15px auto;
  width: 100%;
  --border-radius: 6px;
  color: #fff;
  font-family: AppFontEintrachtOFCSans;
  font-weight: 700;
  text-transform: capitalize;
  font-size: 1rem;
  min-height: 50px;
}
.footer-finish-btn.eintracht .total {
  margin: 0 0 14px;
}
.footer-finish-btn.eintracht .total .total-title, .footer-finish-btn.eintracht .total .total-sum {
  font-family: AppFontEintrachtOFCSans;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
}
.footer-finish-btn.eintracht .total .total-title .total-count, .footer-finish-btn.eintracht .total .total-sum .total-count {
  color: #B3B6B9;
  font-weight: 400;
}

.pickup-location {
  background: var(--ion-color-dark);
  color: var(--ion-color-white);
  padding: 10px 0;
  clip-path: polygon(var(--size-skew) 0, 100% 0, 100% calc(100% - var(--size-skew)), calc(100% - var(--size-skew)) 100%, 0 100%, 0 var(--size-skew));
  margin: 20px;
  margin-top: 10px;
}
.pickup-location h3 {
  margin-left: 30px;
  margin-top: 7px;
  margin-bottom: 5px;
}
.pickup-location__content {
  display: flex;
}
.pickup-location .pickup-location-text {
  margin-left: 20px;
}
.pickup-location .pickup-location-text span {
  font-weight: 700;
}

.toolbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  background: white;
  align-items: center;
  box-shadow: 0px -4px 15px 0px rgba(79, 97, 79, 0.2509803922);
}
.toolbar p {
  margin: 0px;
  color: var(--ion-color-secondary) !important;
}

.promo-info {
  align-items: center;
  padding: 10px 17px;
  background: white;
  margin: 10px 10px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  display: none;
}
.promo-info .name {
  width: 180px;
}

.min-order {
  margin: 10px 10px 0;
}

.add-more {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 34px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding-inline: 7px;
  cursor: pointer;
  border-radius: 22px;
  background-color: var(--ion-color-primary);
  padding: 10px;
}
.add-more .add-text {
  font-family: AppFontBold;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0px;
  text-align: left;
  color: white;
}
.add-more .add-button {
  margin-right: 12px;
}

.card-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.time-selection {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 30px 18px 10px;
}
.time-selection .plump {
  height: 51px;
  width: 54px;
  margin-right: 24px;
}
.time-selection .time-selection-text-block {
  flex-grow: 1;
}
.time-selection .time-selection-text {
  font-family: Title;
  font-size: 32px;
  line-height: 110%;
  letter-spacing: 2%;
  vertical-align: middle;
  text-transform: uppercase;
  vertical-align: baseline;
}
.time-selection .table-number {
  color: var(--ion-color-primary);
}

.ordered-articles {
  margin: 0 20px;
  overflow: auto;
  height: calc(100% - 330px);
}

.promo-code {
  width: 100%;
}

.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

.title {
  font-family: AppFontBold;
  font-size: 25px;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
  margin-bottom: 18px;
}

.promo-error {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: red;
  display: none;
}

.no-articles {
  display: flex;
}
.no-articles ion-icon {
  color: white;
  fill: white;
  margin-right: 10px;
  display: none;
}
@media (min-width: 991px) {
  .no-articles ion-icon {
    fill: black;
    color: black;
  }
}
@media (min-width: 991px) {
  .no-articles ion-icon.big-screen {
    display: block;
  }
}
@media (max-width: 992px) {
  .no-articles ion-icon.small-screen {
    display: block;
  }
}
.no-articles h3 {
  color: var(--color-black);
  font-family: var(--ion-font-family);
  font-size: 16px;
}

.footer-finish-btn {
  padding: 10px 20px;
  background: #231F20;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-top: 25px;
}
.footer-finish-btn .checkout-btn {
  width: 100%;
  max-height: 50px;
  text-transform: none;
}
.footer-finish-btn .checkout-btn.btn {
  font-family: var(--ion-font-family);
  background-color: var(--ion-color-white);
  padding: 5px;
  --border-width: 0px;
  color: #231F20;
  text-transform: none;
}
.footer-finish-btn .footer-btn {
  width: 100%;
  max-height: 50px;
  --border-width: 0px;
  padding: 5px;
  margin: 15px auto;
  margin-top: 0;
  font-family: var(--ion-font-family);
}
.footer-finish-btn .footer-btn.btn::before {
  background-color: var(--ion-color-white);
}
.footer-finish-btn .footer-btn.btn-outline {
  color: var(--ion-color-white);
}
.footer-finish-btn span {
  padding-top: 2px;
}

.finish-btn {
  padding: 10px 20px;
  border-bottom: 1px solid #ebdfda;
}
@media (max-width: 992px) {
  .finish-btn {
    display: none;
  }
}
.finish-btn .footer-btn {
  width: 100%;
}
.finish-btn .footer-btn .footer-btn-text {
  font-size: 14px !important;
  color: white;
  font-family: AppFont, sans-serif;
}

.promo-section {
  border-top: 1px solid var(--color-black);
  border-bottom: 1px solid var(--color-black);
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (max-width: 992px) {
  .promo-section {
    padding: 5px 20px;
  }
}
.promo-section.no-border {
  border-top: none;
}
.promo-section ion-icon {
  width: 30px;
  height: 30px;
}
.promo-section h3 {
  margin-left: 10px;
  font-size: 16px;
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
}
@media (max-width: 992px) {
  .promo-section h3 {
    font-size: 14px;
  }
}

.tips {
  padding: 10px 20px 0px;
}

.kaisin-points {
  padding: 8px 15px;
}
.kaisin-points .wrapper-kaisin-block {
  background: #ebdfda;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.kaisin-points .wrapper-kaisin-block .left-info {
  padding: 5px 20px;
  width: 60%;
  text-transform: uppercase;
}
.kaisin-points .wrapper-kaisin-block .left-info h3 {
  font-family: AppFontMedium;
  font-weight: bold;
  font-size: 14px;
}
.kaisin-points .wrapper-kaisin-block .left-info p {
  font-size: 10px;
  font-family: AppFont;
}
.kaisin-points .wrapper-kaisin-block .right-info {
  padding: 5px 20px;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.kaisin-points .wrapper-kaisin-block .right-info ion-img {
  width: 50px;
  height: 50px;
}
.kaisin-points .wrapper-kaisin-block .right-info p {
  padding-right: 5px;
  font-weight: bold;
}
.kaisin-points .wrapper-kaisin-block .register-section {
  width: 100%;
  padding: 8px 10px;
  border-top: 1px solid var(--color-black);
  display: flex;
  justify-content: space-between;
}
.kaisin-points .wrapper-kaisin-block .register-section ion-button {
  --background: transparent;
  color: var(--color-black);
  min-height: 28px;
  font-size: 12px;
  width: 48%;
}

.delete-promo {
  justify-content: space-between;
}
.delete-promo .delete-items-section {
  display: flex;
  align-items: center;
}
.delete-promo .delete-items-section ion-icon {
  margin-left: 15px;
}

.form-section-input .form-section-title {
  padding-top: 15px;
  padding-bottom: 20px;
  border-top: 1px solid var(--color-black);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 992px) {
  .form-section-input .form-section-title {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
.form-section-input .form-section-title .rotate-icon {
  rotate: 0deg;
  transition: rotate 0.5s ease-in-out;
}
.form-section-input .form-section-title .rotate-icon.rotate {
  rotate: 180deg;
}
.form-section-input h3 {
  font-size: 16px;
  text-transform: uppercase;
  color: var(--color-black);
}
.form-section-input .input-forms {
  max-height: auto;
  height: -moz-fit-content;
  height: fit-content;
  transition: opacity 0.1s ease-in-out, max-height 0.5s cubic-bezier(0, 1, 0, 1);
}
.form-section-input .input-forms.hide {
  height: 0px;
  min-height: 0px;
  min-height: 0px;
  max-height: 0px;
  opacity: 0;
  overflow: hidden;
}
.form-section-input .input-forms .top-form-wrapper {
  padding: 0 16px;
}
.form-section-input .input-forms ion-label {
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-black);
}
.form-section-input .input-forms .title-label {
  font-family: AppFontBold;
  font-size: 16px;
}

.address-selection {
  padding: 13px 20px;
}
.address-selection h3 {
  font-size: 14px;
}

.name_row {
  padding: 10px 10px 13px 15px;
  color: var(--color-black);
  display: flex;
  align-items: center;
  border-top: 1px solid var(--color-black);
}

.name-block b {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--ion-color-main);
}

.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
}
.circle ion-icon {
  width: 30px;
  height: 30px;
}

.error_container {
  margin: 0;
  margin-top: 5px;
  margin-bottom: 5px;
}

.added-gift {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  border-bottom: 1px solid var(--color-black);
  cursor: pointer;
}
.added-gift .header-gift {
  width: 35px;
  height: 35px;
  min-height: 35px;
  min-width: 35px;
  background: #f48b7f;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.added-gift .inner-text-gift {
  margin-left: 5px;
}
.added-gift .inner-text-gift h3 {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .inner-text-gift p {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .delete-items-section {
  margin-left: auto;
}
.added-gift ion-icon {
  width: 25px;
  height: 25px;
}

.error-message {
  text-align: center;
  color: var(--ion-color-secondary);
  padding-bottom: 5px;
  font-size: 12px;
}

.promo-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  padding-block: 13px;
  margin-inline: 18px;
  margin-bottom: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.3019607843);
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}
.promo-block ion-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
}
.promo-block .promo-text {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
}
.promo-block ion-img {
  width: 50px;
  margin-right: auto;
}
.promo-block .delete-items-section {
  margin-left: auto;
}

.total {
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.total .total-title,
.total .total-sum {
  font-size: 18px;
  font-weight: 700;
  line-height: 120%;
  text-align: right;
  vertical-align: bottom;
  text-transform: capitalize;
  color: var(--ion-color-white);
}
.total .total-title .total-count,
.total .total-sum .total-count {
  color: #B3B6B9;
}

.quantity {
  width: 25px;
  height: 25px;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  background: var(--color-background-alt);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: var(--color-black);
}

.bottom-line {
  clip-path: polygon(30px 0, 100% 0, 100% 100%, 0 100%, 0 30px);
  background-image: url('bottom-line-home.png');
  background-color: #231f20;
  background-size: contain;
  background-repeat: repeat-x;
  width: 100%;
  position: absolute;
  top: -30px;
  height: 31px;
  left: 0;
}

.recomendation {
  background: linear-gradient(360deg, #FFFFFF 0%, #F5F5F5 35.53%);
  margin: 15px auto;
}
.recomendation .recomendation-title {
  padding: 20px;
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  vertical-align: middle;
}
.recomendation .swiper-slide {
  min-width: 176px;
  height: auto;
}

.full-h {
  height: 100%;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA;EACC,YAAA;AAFD;AAIC;EACC,YAAA;AAFF;AAIC;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;AAFF;AAOE;EACC,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AALH;AAMG;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AAJJ;AAOE;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AALJ;AAMI;;EAEC,SAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAJL;AAMI;EACC,cAAA;AAJL;AAKK;EACC,gBAAA;EACA,cAAA;AAHN;;AAWE;EACC,mBAAA;EACA,uBAAA;AARH;AASG;EACC,gBAAA;AAPJ;AASG;EACC,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAPJ;AASG;EACK,uBAAA;EACH,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,oCAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AAPL;AASG;EACE,gBAAA;AAPL;AAQK;EACC,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AANN;AAOQ;EACE,cAAA;EACA,gBAAA;AALV;;AAYA;EACC,iCAAA;EACA,6BAAA;EACA,eAAA;EACA,kJAAA;EAMA,YAAA;EACA,gBAAA;AAdD;AAQC;EACC,iBAAA;EACA,eAAA;EACA,kBAAA;AANF;AAUC;EACC,aAAA;AARF;AAUC;EACC,iBAAA;AARF;AASE;EACC,gBAAA;AAPH;;AAaA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4DAAA;AAVD;AAWC;EACC,WAAA;EACA,4CAAA;AATF;;AAYA;EACC,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,aAAA;AAdD;AAUC;EACC,YAAA;AARF;;AAcA;EACC,mBAAA;AAXD;;AAcA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;AAXD;AAYC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAVF;AAaC;EACC,kBAAA;AAXF;;AAeA;EAEC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAbD;;AAkBA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;AAfD;AAgBC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAdF;AAiBC;EACC,YAAA;AAfF;AAkBC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;AAhBF;AAmBC;EACC,+BAAA;AAjBF;;AAqBA;EACC,cAAA;EACA,cAAA;EACG,0BAAA;AAlBJ;;AAqBA;EACC,WAAA;AAlBD;;AAoBA;EACC,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAjBD;AC1NE;EDsOF;IAOE,YAAA;EAfA;AACF;;AAmBA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAhBD;;AAmBA;EACC,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAhBD;;AAmBA;EACC,aAAA;AAhBD;AAiBC;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EAMA,aAAA;AApBF;ACjQE;ED4QD;IAME,WAAA;IACA,YAAA;EAbD;AACF;ACvQE;EDsRA;IAEE,cAAA;EAbF;AACF;ACtQE;EDqRA;IAEE,cAAA;EAbF;AACF;AAgBC;EACC,yBAAA;EACA,mCAAA;EACA,eAAA;AAdF;;AAiBA;EACC,kBAAA;EACA,mBAAA;EAGA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;AAhBD;AAiBC;EACC,WAAA;EACA,gBAAA;EACA,oBAAA;AAfF;AAgBE;EACC,mCAAA;EACA,wCAAA;EACA,YAAA;EACG,mBAAA;EACH,cAAA;EACA,oBAAA;AAdH;AAkBC;EAIC,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACG,iBAAA;EACH,aAAA;EACA,mCAAA;AAnBF;AAoBE;EACC,wCAAA;AAlBH;AAoBE;EACC,6BAAA;AAlBH;AA0BC;EACC,gBAAA;AAxBF;;AA+BA;EACC,kBAAA;EAYA,gCAAA;AAvCD;AC9TE;EDwVF;IAGE,aAAA;EAzBA;AACF;AA0BC;EACC,WAAA;AAxBF;AAyBE;EACC,0BAAA;EACA,YAAA;EACA,gCAAA;AAvBH;;AA4BA;EACC,wCAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAzBD;ACpVE;EDuWF;IAQE,iBAAA;EAvBA;AACF;AAwBC;EACC,gBAAA;AAtBF;AAwBC;EACC,WAAA;EACA,YAAA;AAtBF;AAwBC;EACC,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AAtBF;ACtWE;EDwXD;IAME,eAAA;EApBD;AACF;;AAuBA;EACC,sBAAA;AApBD;;AAsBA;EACC,iBAAA;AAnBD;AAqBC;EACC,mBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AApBF;AAqBE;EACC,iBAAA;EACA,UAAA;EACA,yBAAA;AAnBH;AAoBG;EACC,0BAAA;EACA,iBAAA;EACA,eAAA;AAlBJ;AAoBG;EACC,eAAA;EACA,oBAAA;AAlBJ;AAqBE;EACC,iBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAnBH;AAoBG;EACC,WAAA;EACA,YAAA;AAlBJ;AAoBG;EACC,kBAAA;EACA,iBAAA;AAlBJ;AAqBE;EACC,WAAA;EACA,iBAAA;EACA,wCAAA;EACA,aAAA;EACA,8BAAA;AAnBH;AAoBG;EACC,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAlBJ;;AAwBA;EACC,8BAAA;AArBD;AAsBC;EACC,aAAA;EACA,mBAAA;AApBF;AAqBE;EACC,iBAAA;AAnBH;;AAwBC;EACC,iBAAA;EACA,oBAAA;EACA,wCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AArBF;AC1bE;EDycD;IASE,gBAAA;IACA,mBAAA;EApBD;AACF;AAqBE;EACC,YAAA;EACA,mCAAA;AAnBH;AAoBG;EACC,cAAA;AAlBJ;AAsBC;EACC,eAAA;EACA,yBAAA;EACA,yBAAA;AApBF;AAsBC;EACC,gBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,8EAAA;AApBF;AAqBE;EACC,WAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AAnBH;AAsBE;EACC,eAAA;AApBH;AAuBE;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AArBH;AAwBE;EACC,wBAAA;EACA,eAAA;AAtBH;;AA0BA;EACC,kBAAA;AAvBD;AAwBC;EACC,eAAA;AAtBF;;AA0BA;EACC,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;AAvBD;;AA0BC;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;AAvBF;;AA2BA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;AAzBD;AA0BC;EACC,WAAA;EACA,YAAA;AAxBF;;AA4BA;EACC,SAAA;EACA,eAAA;EACA,kBAAA;AAzBD;;AA4BA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2CAAA;EACA,eAAA;AAzBD;AA0BC;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAxBF;AA0BC;EACC,gBAAA;AAxBF;AAyBE;EACC,0BAAA;EACA,yBAAA;EACA,eAAA;AAvBH;AAyBE;EACC,0BAAA;EACA,yBAAA;EACA,eAAA;AAvBH;AA0BC;EACC,iBAAA;AAxBF;AA0BC;EACC,WAAA;EACA,YAAA;AAxBF;;AA2BA;EACC,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,eAAA;AAxBD;;AA0BA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iDAAA;EACA,oDAAA;AAxBD;AA0BC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAxBF;AA0BC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAxBF;AA0BC;EACC,WAAA;EACA,kBAAA;AAxBF;AA0BC;EACC,iBAAA;AAxBF;;AAgDA;EACC,UAAA;EACA,WAAA;EACG,aAAA;EACA,8BAAA;EACH,mBAAA;AA7CD;AA+CC;;EAEC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;AA7CF;AA8CE;;EACC,cAAA;AA3CH;;AA8DA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AA3DF;;AA6DA;EACI,6DAAA;EACA,6CAAA;EACA,yBAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;EACH,UAAA;EACA,YAAA;EACA,OAAA;AA1DD;;AA4DA;EACC,+DAAA;EACA,iBAAA;AAzDD;AA0DC;EACC,aAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAxDF;AA0DC;EACK,gBAAA;EACH,YAAA;AAxDH;;AA2DA;EACC,YAAA;EACA,gBAAA;AAxDD","sourcesContent":["@import '../../../theme/mixins';\n\n\n.order-wrapper {\n\theight: 100%;\n\t// min-height: fit-content;\n\t&.recomendation {\n\t\theight: 95vh;\n\t}\n\th1 {\n\t\tpadding: 0 20px;\n\t\tfont-weight: 700;\n\t\tfont-size: 36px;\n\t\tline-height: 100%;\n\t\tvertical-align: middle;\n\t\tcolor: var(--ion-color-dark);\n\t}\n\n\t&.eintracht {\n\t.order-header{\n\t\th1 {\n\t\t\tposition: relative;\n\t\t\tfont-family: AppFontEintrachtOFC;\n\t\t\tcolor: #fff;\n\t\t\tmargin: 0 auto;\n\t\t\tpadding: 12px 20px 20px;\n\t\t\tfont-size: 30px;\n\t\t\t&::after {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: 5px;\n\t\t\t\tleft: 20px;\n\t\t\t\theight: 3px;\n\t\t\t\twidth: 182px;\n\t\t\t\tbackground: var(--ion-color-eintracht-red);\n\t\t\t}\n\t\t}\n\t\t.pickup-location {\n\t\t\t\tbackground: #000000;\n\t\t\t\tmargin: 11px 20px 12px;\n\t\t\t\tpadding: 10px;\n\t\t\t\tclip-path: none;\n\t\t\t\th3,\n\t\t\t\t.pickup-location-text h4 {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tfont-family: AppFontEintrachtOFCSans;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 22px;\n\t\t\t\t\tline-height: 120%;\n\t\t\t\t}\n\t\t\t\t.pickup-location-text {\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\th4 span {\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tcolor: #E30613;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t}\n\t}\n}\n}\n\t.footer-finish-btn {\n\t\t&.eintracht {\n\t\t\tbackground: #121212;\n\t\t\tpadding: 17px 20px 25px;\n\t\t\t.amex-offer {\n\t\t\t\tmargin: 0 0 14px;\n\t\t\t}\n\t\t\t.checkout-btn {\n\t\t\t\t--border-width: 0px;\n\t\t\t\theight: 50px;\n\t\t\t\tmin-height: 50px;\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 130%;\n\t\t\t}\n\t\t\t.footer-btn-outline {\n\t\t\t\t    --border-color: #E30613;\n\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\tmargin: 15px auto;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t--border-radius: 6px;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\tfont-family: AppFontEintrachtOFCSans;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tmin-height: 50px;\n\t\t\t}\n\t\t\t.total {\n\t\t\t\t\tmargin: 0 0 14px;\n\t\t\t\t\t.total-title, .total-sum {\n\t\t\t\t\t\tfont-family: AppFontEintrachtOFCSans;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\tline-height: 22px;\n\t\t\t\t\t\t\t\t.total-count {\n\t\t\t\t\t\t\t\t\t\tcolor:#B3B6B9;\n\t\t\t\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t}\n\t}\n}\n\n.pickup-location {\n\tbackground: var(--ion-color-dark);\n\tcolor: var(--ion-color-white);\n\tpadding: 10px 0;\n\tclip-path: polygon(var(--size-skew) 0, 100% 0, 100% calc(100% - var(--size-skew)), calc(100% - var(--size-skew)) 100%, 0 100%, 0 var(--size-skew));\n\th3 {\n\t\tmargin-left: 30px;\n\t\tmargin-top: 7px;\n\t\tmargin-bottom: 5px;\n\t}\n\tmargin: 20px;\n\tmargin-top: 10px;\n\t&__content{\n\t\tdisplay: flex;\n\t}\n\t.pickup-location-text {\n\t\tmargin-left: 20px;\n\t\tspan {\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n}\n\n\n.toolbar {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px 20px;\n\tbackground: white;\n\talign-items: center;\n\tbox-shadow: 0px -4px 15px 0px #4f614f40;\n\tp {\n\t\tmargin: 0px;\n\t\tcolor: var(--ion-color-secondary) !important;\n\t}\n}\n.promo-info {\n\talign-items: center;\n\tpadding: 10px 17px;\n\tbackground: white;\n\tmargin: 10px 10px 0;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\n\t.name {\n\t\twidth: 180px;\n\t}\n\n\tdisplay: none;\n}\n\n.min-order {\n\tmargin: 10px 10px 0;\n}\n\n.add-more {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\theight: 34px;\n\tmin-width: fit-content;\n\tpadding-inline: 7px;\n\tcursor: pointer;\n\tborder-radius: 22px;\n\tbackground-color: var(--ion-color-primary);\n\tpadding: 10px;\n\t.add-text {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 11px;\n\t\tline-height: 13px;\n\t\tletter-spacing: 0px;\n\t\ttext-align: left;\n\t\tcolor: white;\n\t}\n\n\t.add-button {\n\t\tmargin-right: 12px;\n\t}\n}\n\n.card-actions {\n\t// height: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n\n\n.time-selection {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tpadding: 30px 18px 10px;\n\t.plump {\n\t\theight: 51px;\n\t\twidth: 54px;\n\t\tmargin-right: 24px;\n\t}\n\n\t.time-selection-text-block {\n\t\tflex-grow: 1;\n\t}\n\n\t.time-selection-text {\n\t\tfont-family: Title;\n\t\tfont-size: 32px;\n\t\tline-height: 110%;\n\t\tletter-spacing: 2%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tvertical-align: baseline;\n\t}\n\n\t.table-number {\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n.ordered-articles {\n\tmargin: 0 20px;\n\toverflow: auto;\n    height: calc(100% - 330px);\n}\n\n.promo-code {\n\twidth: 100%;\n}\n.article {\n\ttext-align: center;\n\theight: 110px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t@include mobile {\n\t\theight: 35px;\n\t}\n}\n\n\n.title {\n\tfont-family: AppFontBold;\n\tfont-size: 25px;\n\tline-height: 21px;\n\tletter-spacing: 0em;\n\ttext-align: center;\n\tcolor: #000;\n\tmargin-bottom: 18px;\n}\n\n.promo-error {\n\tmargin: 10px;\n\tfont-size: 13px;\n\ttext-align: center;\n\tcolor: red;\n\tdisplay: none;\n}\n\n.no-articles {\n\tdisplay: flex;\n\tion-icon {\n\t\tcolor: white;\n\t\tfill: white;\n\t\tmargin-right: 10px;\n\n\t\t@include desktop {\n\t\t\tfill: black;\n\t\t\tcolor: black;\n\t\t}\n\t\tdisplay: none;\n\t\t&.big-screen {\n\t\t\t@include desktop {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t\t&.small-screen {\n\t\t\t@include mobile {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\th3 {\n\t\tcolor: var(--color-black);\n\t\tfont-family: var(--ion-font-family);\n\t\tfont-size: 16px;\n\t}\n}\n.footer-finish-btn {\n\tpadding: 10px 20px;\n\tbackground: #231F20;\n\t// position: relative;\n\t// margin-top: 60px;\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpadding-top: 25px;\n\t.checkout-btn {\n\t\twidth: 100%;\n\t\tmax-height: 50px;\n\t\ttext-transform: none;\n\t\t&.btn {\n\t\t\tfont-family: var(--ion-font-family);\n\t\t\tbackground-color: var(--ion-color-white);\n\t\t\tpadding: 5px;\n    \t\t--border-width: 0px;\n\t\t\tcolor: #231F20;\n\t\t\ttext-transform: none\n\t\t};\n\t}\n\n\t.footer-btn {\n\t\t// &:hover {\n\t\t// \t--background: var(--primary-btn) !important;\n\t\t// }\n\t\twidth: 100%;\n\t\tmax-height: 50px;\n\t\t--border-width: 0px;\n\t\tpadding: 5px;\n    \tmargin: 15px auto;\n\t\tmargin-top: 0;\n\t\tfont-family: var(--ion-font-family);\n\t\t&.btn::before {\n\t\t\tbackground-color: var(--ion-color-white);\n\t\t}\n\t\t&.btn-outline {\n\t\t\tcolor: var(--ion-color-white);\n\t\t}\n\t\t// .footer-btn-text {\n\t\t// \tfont-size: 14px !important;\n\t\t// \tcolor: white;\n\t\t// \tfont-family: AppFont, sans-serif;\n\t\t// }\n\t}\n\tspan {\n\t\tpadding-top: 2px;\n\t}\n}\n// .border-top {\n\t// border-top: 1px solid var(--color-black);\n// }\n\n.finish-btn {\n\tpadding: 10px 20px;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t.footer-btn {\n\t\twidth: 100%;\n\t\t.footer-btn-text {\n\t\t\tfont-size: 14px !important;\n\t\t\tcolor: white;\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t}\n\t}\n\tborder-bottom: 1px solid #ebdfda;\n}\n.promo-section {\n\tborder-top: 1px solid var(--color-black);\n\tborder-bottom: 1px solid var(--color-black);\n\tpadding: 10px 20px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\t@include mobile {\n\t\tpadding: 5px 20px;\n\t}\n\t&.no-border {\n\t\tborder-top: none;\n\t}\n\tion-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n\th3 {\n\t\tmargin-left: 10px;\n\t\tfont-size: 16px;\n\t\tfont-family: AppFont, sans-serif;\n\t\ttext-transform: uppercase;\n\t\t@include mobile {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n}\n.tips {\n\tpadding: 10px 20px 0px;\n}\n.kaisin-points {\n\tpadding: 8px 15px;\n\n\t.wrapper-kaisin-block {\n\t\tbackground: #ebdfda;\n\t\tborder-radius: 18px;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t\t.left-info {\n\t\t\tpadding: 5px 20px;\n\t\t\twidth: 60%;\n\t\t\ttext-transform: uppercase;\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tfont-size: 10px;\n\t\t\t\tfont-family: AppFont;\n\t\t\t}\n\t\t}\n\t\t.right-info {\n\t\t\tpadding: 5px 20px;\n\t\t\twidth: 40%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-end;\n\t\t\tion-img {\n\t\t\t\twidth: 50px;\n\t\t\t\theight: 50px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tpadding-right: 5px;\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\t\t}\n\t\t.register-section {\n\t\t\twidth: 100%;\n\t\t\tpadding: 8px 10px;\n\t\t\tborder-top: 1px solid var(--color-black);\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tion-button {\n\t\t\t\t--background: transparent;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tmin-height: 28px;\n\t\t\t\tfont-size: 12px;\n\t\t\t\twidth: 48%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.delete-promo {\n\tjustify-content: space-between;\n\t.delete-items-section {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tion-icon {\n\t\t\tmargin-left: 15px;\n\t\t}\n\t}\n}\n.form-section-input {\n\t.form-section-title {\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 20px;\n\t\tborder-top: 1px solid var(--color-black);\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t@include mobile {\n\t\t\tpadding-top: 5px;\n\t\t\tpadding-bottom: 5px;\n\t\t}\n\t\t.rotate-icon {\n\t\t\trotate: 0deg;\n\t\t\ttransition: rotate 0.5s ease-in-out;\n\t\t\t&.rotate {\n\t\t\t\trotate: 180deg;\n\t\t\t}\n\t\t}\n\t}\n\th3 {\n\t\tfont-size: 16px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--color-black);\n\t}\n\t.input-forms {\n\t\tmax-height: auto;\n\t\theight: fit-content;\n\t\ttransition: opacity 0.1s ease-in-out, max-height 0.5s cubic-bezier(0, 1, 0, 1);\n\t\t&.hide {\n\t\t\theight: 0px;\n\t\t\tmin-height: 0px;\n\t\t\tmin-height: 0px;\n\t\t\tmax-height: 0px;\n\t\t\topacity: 0;\n\t\t\toverflow: hidden;\n\t\t}\n\n\t\t.top-form-wrapper {\n\t\t\tpadding: 0 16px;\n\t\t}\n\n\t\tion-label {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0.08em;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\n\t\t.title-label {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n}\n.address-selection {\n\tpadding: 13px 20px;\n\th3 {\n\t\tfont-size: 14px;\n\t}\n}\n\n.name_row {\n\tpadding: 10px 10px 13px 15px;\n\tcolor: var(--color-black);\n\tdisplay: flex;\n\talign-items: center;\n\tborder-top: 1px solid var(--color-black);\n}\n.name-block {\n\tb {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-main);\n\t}\n}\n\n.circle {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\twidth: 30px;\n\theight: 30px;\n\tion-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t}\n}\n\n.error_container {\n\tmargin: 0;\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n}\n\n.added-gift {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tpadding: 5px 20px;\n\tborder-bottom: 1px solid var(--color-black);\n\tcursor: pointer;\n\t.header-gift {\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tmin-height: 35px;\n\t\tmin-width: 35px;\n\t\tbackground: #f48b7f;\n\t\tborder: 1px solid var(--color-black);\n\t\tborder-radius: 50%;\n\t\tfont-size: 10px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t}\n\t.inner-text-gift {\n\t\tmargin-left: 5px;\n\t\th3 {\n\t\t\tfont-family: AppFontMedium;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 12px;\n\t\t}\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n\t.delete-items-section {\n\t\tmargin-left: auto;\n\t}\n\tion-icon {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t}\n}\n.error-message {\n\ttext-align: center;\n\tcolor: var(--ion-color-secondary);\n\tpadding-bottom: 5px;\n\tfont-size: 12px;\n}\n.promo-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tcursor: pointer;\n\n\tpadding-block: 13px;\n\tmargin-inline: 18px;\n\tmargin-bottom: 10px;\n\tborder-top: 1px solid #0000004d;\n\tborder-bottom: 1px solid #0000004d;\n\n\tion-icon {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tmargin-right: 8px;\n\t}\n\t.promo-text {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 8%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n\tion-img {\n\t\twidth: 50px;\n\t\tmargin-right: auto;\n\t}\n\t.delete-items-section {\n\t\tmargin-left: auto;\n\t}\n}\n\n// .button-row {\n// \tpadding: 20px 18px;\n// \tborder-top: 1px solid #0000004d;\n// \tborder-bottom: 1px solid #0000004d;\n// }\n\n// .sub-total {\n// \tpadding: 0;\n// \tmargin-bottom: 8px;\n// \t.sub-total-title,\n// \t.sub-total-sum {\n// \t\tfont-family: AppFont;\n// \t\tfont-size: 10px;\n// \t\tline-height: 120%;\n// \t\tletter-spacing: 8%;\n// \t\tvertical-align: middle;\n// \t\ttext-transform: uppercase;\n// \t}\n// }\n\n.total {\n\tpadding: 0;\n\twidth: 100%;\n    display: flex;\n    justify-content: space-between;\n\tmargin-bottom: 20px;\n\n\t.total-title,\n\t.total-sum {\n\t\tfont-size: 18px;\n\t\tfont-weight: 700;\n\t\tline-height: 120%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: capitalize;\n\t\tcolor: var(--ion-color-white);\n\t\t.total-count {\n\t\t\tcolor:#B3B6B9;\n\t}\n\t}\n\n}\n\n// .total-points {\n// \twidth: 100%;\n// \tdisplay: flex;\n// \tjustify-content: flex-end;\n// \tpadding: 0px 20px;\n// \ttext-transform: uppercase;\n\n// \tspan {\n// \t\tcolor: #f48b7f;\n// \t\tfont-size: 12px;\n// \t}\n// }\n\n.quantity {\n  width: 25px;\n  height: 25px;\n  border: 1px solid var(--color-black);\n  border-radius: 50%;\n  background: var(--color-background-alt);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n  color: var(--color-black);\n}\n.bottom-line {\n    clip-path: polygon(30px 0, 100% 0, 100% 100%, 0 100%, 0 30px);\n    background-image: url(../../../assets/eintracht/bottom-line-home.png);\n    background-color: #231f20;\n    background-size: contain;\n    background-repeat: repeat-x;\n    width: 100%;\n    position: absolute;\n\ttop: -30px;\n\theight: 31px;\n\tleft:0\n}\n.recomendation {\n\tbackground: linear-gradient(360deg, #FFFFFF 0%, #F5F5F5 35.53%);\n\tmargin: 15px auto;\n\t.recomendation-title {\n\t\tpadding: 20px;\n\t\tfont-family: var(--ion-font-family);\n\t\tfont-weight: 700;\n\t\tfont-size: 16px;\n\t\tline-height: 100%;\n\t\tvertical-align: middle;\n\t}\n\t.swiper-slide {\n      min-width: 176px;\n\t  height: auto;\n    }\n}\n.full-h{\n\theight: 100%;\n\toverflow: hidden;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
